<div fxFlexFill fxLayout="column" fxLayoutGap="10px" style="margin-bottom:20px;">

  <!-- Header Section Starts -->
  <span fxLayout="row" class="div-header">
    <span fxFlex fxLayoutAlign="center center" fxLayout="row">
      <span class="heading medium" ngClass.xs="heading-xs medium">{{'check_in_details' | transloco}}</span>
    </span>
  </span>

  <div fxLayout="column" class="div-inner div-box" fxLayoutGap="10px" [class.mat-elevation-z3]="true">

    <div fxFlex fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px">
      <img alt="img" id="img-workingType" [src]="statusImage" />
      <span id="span-working-title">{{statusTitleLocal}}</span>
    </div>

    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="60px" fxLayoutGap.xs="0px">

      <div fxLayout="row" fxFlex="50" fxFlex.xs="100" fxFlexAlign="start">
        <span>
          <a class="check-in-for " ngStyle.xs="font-size:12px">{{'check_in_for' | transloco}}:</a>
          <a ngStyle.xs="font-size:12px" id="text"> {{proxyCheckInArray.length}} {{'crew_member' | transloco}}</a>
        </span>
      </div>
    </div>

  </div>

  <!-- Check In List Section Starts -->
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="60px" fxLayoutGap.xs="0px" class="div-inner div-checkinlist ">

    <div fxLayout="row" fxFlex="50">
      <span fxLayoutAlign="start center" ngStyle.xs="font-size:14px"
        id="text-crew">{{'crew_member_list' | transloco}}</span>
    </div>

    <div fxLayout="row" fxFlex="50" fxFlex.xs="100">
    </div>
  </div>

  <mat-divider style="padding-bottom: 0px !important;"></mat-divider>
  <!-- User Profile List Starts -->
  <div fxLayout="column" fxLayoutGap="20px" class="scrollable">
    <mat-list style="padding:0px !important;">
      <mat-list-item class="listitem-padding" *ngFor="let user of proxyCheckInArray; let i = index">
        <div fxFlex fxLayout="row" class="list">
          <div fxLayout="column" fxLayoutAlign=" start center" style="padding-bottom:15px;">
            <span class="name">{{user.name}}</span>
            <span class="designation">{{user.jobTitle}}</span>
          </div>
        </div>
        <mat-divider></mat-divider>
      </mat-list-item>

    </mat-list>
  </div>

  <!-- Button Section starts -->
  <div fxLayout="column" fxFlexLayoutAlign="center center">
    <div fxLayoutAlign="center" style="margin-bottom:3%;margin-top: 5%;">
      <button color="primary" ngStyle.xs="width:150px" mat-flat-button style="border-radius: 24px; width: 280px;"
        (click)="onCancel()">{{'close' | transloco}}</button>
    </div>
  </div>

</div>
